import api from './api';

class RolePermissionService {
  // ================ ROLES ================
  
  async getRoles() {
    try {
      const response = await api.get('/roles');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getRole(id) {
    try {
      const response = await api.get(`/roles/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createRole(roleData) {
    try {
      const response = await api.post('/roles', roleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updateRole(id, roleData) {
    try {
      const response = await api.put(`/roles/${id}`, roleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async deleteRole(id) {
    try {
      const response = await api.delete(`/roles/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async assignPermissionsToRole(roleId, permissionIds) {
    try {
      const response = await api.post(`/roles/${roleId}/permissions`, {
        permissionIds
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getRolePermissions(roleId) {
    try {
      const response = await api.get(`/roles/${roleId}/permissions`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // ================ PERMISOS ================
  
  async getPermissions() {
    try {
      const response = await api.get('/permissions');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getResourcesAndActions() {
    try {
      const response = await api.get('/permissions/resources-actions');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createPermission(permissionData) {
    try {
      const response = await api.post('/permissions', permissionData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // ================ USUARIOS ================
  
  async getUsers() {
    try {
      const response = await api.get('/users');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createUser(userData) {
    try {
      const response = await api.post('/users', userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async resetUserPassword(id, password) {
    try {
      const response = await api.put(`/users/${id}/reset-password`, { password });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updateUser(id, userData) {
    try {
      const response = await api.put(`/users/${id}`, userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async assignRoleToUser(userId, roleId) {
    try {
      const response = await api.put(`/users/${userId}/role`, { roleId });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getUserPermissions(userId) {
    try {
      const response = await api.get(`/users/${userId}/permissions`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // ================ AUTORIZACIÓN ================
  
  async checkPermission(userId, permission) {
    try {
      const response = await api.post('/authorization/check-permission', {
        userId,
        permission
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async checkPermissions(userId, permissions) {
    try {
      const response = await api.post('/authorization/check-permissions', {
        userId,
        permissions
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getMenuPermissions(userId) {
    try {
      const response = await api.get(`/authorization/menu-permissions/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getMyMenuPermissions() {
    try {
      const response = await api.get('/authorization/my-menu-permissions');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

// Instancia singleton
const rolePermissionService = new RolePermissionService();
export default rolePermissionService;